import { IQuestionAnswerCategoryResponse } from '../../../../model/apm/question-answer/response/question-answer-category-response';

export type QuestionAnswerCategoryState = {
    categories: IQuestionAnswerCategoryResponse[];
    loading: boolean;
    drawer: { open: boolean; category?: IQuestionAnswerCategoryResponse };
};

export enum ACTION_TYPES {
    setCategories = 'setCategories',
    setLoading = 'setLoading',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const QuestionAnswerCategoryReducer = (state: QuestionAnswerCategoryState, action: any): QuestionAnswerCategoryState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setCategories:
            return { ...state, categories: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, category: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
